import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ThongTinCaNhanRoutingModule } from './thong-tin-ca-nhan-routing.module';
import { ThongTinCaNhanComponent } from './thong-tin-ca-nhan.component';
import { SharedModule } from '../../shared/shared.module';
import { MatRadioModule } from '@angular/material/radio';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';

@NgModule({
  declarations: [
    ThongTinCaNhanComponent,
    ChangePasswordComponent
  ],
  imports: [
    CommonModule,
    ThongTinCaNhanRoutingModule,
    SharedModule,
    MatRadioModule,
    MatCheckboxModule,
    MatDialogModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatInputModule,
    MatFormFieldModule
  ]
})
export class ThongTinCaNhanModule { }
